module.exports = require('./lib/password-generator');


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/password-generator/index.js
// module id = 522
// module chunks = 0 3 5